import { FormattedMessage } from 'react-intl'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {BalancesListFilter} from './BalancesListFilter'

const BalancesListToolbar = () => {
  const {setItemIdForUpdate} = useListView()
  const openAddBalanceModal = () => {
    setItemIdForUpdate(null)
  }

  return (
    <div className='d-flex justify-content-end' data-kt-balance-table-toolbar='base'>
      <BalancesListFilter />

      {/* begin::Export */}
      <button type='button' className='btn btn-light-primary me-3'>
        <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
        <FormattedMessage id='TABLE.GENERAL.EXPORT' />      </button>
      {/* end::Export */}

      {/* begin::Add balance */}
      <button type='button' className='btn btn-primary' onClick={openAddBalanceModal}>
        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
        <FormattedMessage id='BALANCE.TABLE.CREATEBALANCE' defaultMessage={"Credit / Debit Balance"}/>
      </button>
      {/* end::Add balance */}
    </div>
  )
}

export {BalancesListToolbar}
